// Lightweight locale constants — NO i18next/react-i18next imports, so server code (metadata,
// sitemap, the `[lang]` layout, the auth loader) can use them without pulling React context
// into build-time config collection. Heavy per-locale instances live in ./instances.js.

// Locales that get a `/{lang}/…` URL prefix. English stays at the un-prefixed root (x-default);
// `en-GB` is intentionally dropped (no distinct URL/value from `en`).
export const SUPPORTED_LOCALES = [
  'de',
  'es',
  'fr',
  'hi',
  'it',
  'ja',
  'ko',
  'pt',
  'zh-CN',
]

// All locales for hreflang (English maps to the root URL).
export const HREFLANG_LOCALES = ['en', ...SUPPORTED_LOCALES]

export const isSupportedLocale = (lang) => SUPPORTED_LOCALES.includes(lang)

const LOCALE_PREFIX = new RegExp(`^/(?:${SUPPORTED_LOCALES.join('|')})(?=/|$)`)

// Strip a leading `/{locale}` segment from a pathname (→ the equivalent English path), e.g.
// `/de/nsfw-ai` → `/nsfw-ai`, `/de` → `/`. Used for route matching that must treat a localized
// page the same as its English original.
export const stripLocalePrefix = (pathname) =>
  (pathname || '').replace(LOCALE_PREFIX, '') || '/'

const PATH_LOCALE = new RegExp(`^/(${SUPPORTED_LOCALES.join('|')})(?=/|$)`)

// Return the locale from a URL's leading segment (`/de/nsfw-ai` → 'de'), or null if none.
export const getPathLocale = (pathname) => {
  const m = (pathname || '').match(PATH_LOCALE)
  return m ? m[1] : null
}

// English paths that HAVE a localized `/{lang}` variant under app/[lang]/. The language
// switcher navigates to the localized URL for these (the URL is the language source of truth
// for SEO pages); everywhere else it falls back to in-place client-side switching. Grow this
// as more pages gain [lang] routes.
export const LOCALIZED_PATHS = new Set(['/', '/nsfw-ai'])

// Build the URL path for `basePath` (an un-prefixed English path) in `lang`.
export const localizedPath = (basePath, lang) =>
  lang === 'en' || !isSupportedLocale(lang)
    ? basePath
    : `/${lang}${basePath === '/' ? '' : basePath}`
